export const LAST_USED_LOGIN_KEY = 'delegate.last-used-login-method.v1';

export type PrimaryLoginMethod = 'passkey' | 'google' | 'password' | 'saml';

const METHODS = new Set<PrimaryLoginMethod>([
  'passkey',
  'google',
  'password',
  'saml',
]);

export function readLastUsedLogin(): PrimaryLoginMethod | null {
  try {
    const value = window.sessionStorage.getItem(LAST_USED_LOGIN_KEY);
    return value && METHODS.has(value as PrimaryLoginMethod)
      ? (value as PrimaryLoginMethod)
      : null;
  } catch {
    return null;
  }
}

export function rememberLastUsedLogin(method: PrimaryLoginMethod): void {
  try {
    window.sessionStorage.setItem(LAST_USED_LOGIN_KEY, method);
  } catch {
    // Privacy modes can disable storage. Login must still succeed.
  }
}
